/** Joins truthy class names: cx("card", isActive && "is-active"). */
export const cx = (...classes) => classes.filter(Boolean).join(" ");

/** 1250 -> "1,250" */
export const formatNumber = (value) => new Intl.NumberFormat("en-US").format(value);

/** "2026-01-14" -> "Jan 14, 2026" */
export const formatDate = (value) =>
  new Date(value).toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" });

/** Smooth-scrolls to a hash target, accounting for the sticky navbar. */
export const scrollToSection = (hash) => {
  const target = document.querySelector(hash);
  if (!target) return;

  const navHeight = parseInt(
    getComputedStyle(document.documentElement).getPropertyValue("--navbar-height"),
    10
  ) || 80;

  window.scrollTo({ top: target.getBoundingClientRect().top + window.scrollY - navHeight - 8, behavior: "smooth" });
};
